// expose internally used `fetch` method for testing/mocking only
module.exports.fetch = require('node-fetch').default
